export default () => ({
  statusGet: undefined,
  statusSet: undefined,
  items: [],
  state: {},
});
